import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SavedSearchModel } from '../../models/saved-search-model';
import { ConstantsService } from '../../services/constants.service';
import { QueryStateService } from '../../services/query-state.service';
import { SavedSearchService } from '../../services/saved-search.service';

@Component({
  selector: 'app-dialog-save-search',
  templateUrl: './dialog-save-search.component.html',
  styleUrls: ['./dialog-save-search.component.css']
})
export class DialogSaveSearchComponent implements OnInit {

    // Saved Search Items
    @Input() saveSearchVisible = false;

    @Output() closeDialog = new EventEmitter<boolean>();

    saveSearchName: string = '';
    isInvalidFilename:boolean = false;

    constructor(
      private saveSearchSvc: SavedSearchService,
      private messageSvc: MessageService,
      private querySvc: QueryStateService
    ) {
    }

    ngOnInit(): void {
      
    }   

    hideDialog() {
      this.closeDialog.emit(false);
      // this.saveSearchVisible = false;
      // this.saveSearchName = '';
    }
  
    executeSavedSearch() {
      this.saveSearchSvc.saveSearch(this.saveSearchName.trim(), this.querySvc.getFormData());
      this.saveSearchVisible = false;
      this.messageSvc.add({ severity: 'success', summary: 'Item Saved!', detail: 'Search has been saved!', key: 'saveSearch' });
      this.saveSearchName = '';
      this.closeDialog.emit(false);
    }
  
    searchNameLength() {
      return this.saveSearchName.trim().length;
    }
  
    validateFilename() {
      const invlaidChars = /[<>:"\/\\|?*\x00-\x1F"]/g;
      this.isInvalidFilename = invlaidChars.test(this.saveSearchName);
    }
}
